// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__FwlHn","section":"styles_section__SzR6e","row":"styles_row__k1D1G","newButton":"styles_newButton__LfB4F","actionBtn":"styles_actionBtn__sMdTk"};